import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubjectService {

  public roleChange = new Subject<string>();



  constructor() { }

  open2FAModal$ = new Subject<void>();
}
